// src/oura/newscan/coreChoice.ts
//
// What the Review's Core service section picks from, in one place: the picker
// (FormAnswers.tsx CorePicker) and whether the section shows (ReviewStep.tsx)
// read the same lists, so the section never shows empty or hides a choice
// the picker has (Jack, #4501).

import type { ScanDraft } from "@service/aeo/scanDraftTypes";

const same = (x: string, y: string) => x.trim().toLowerCase() === y.trim().toLowerCase();
const unique = (xs: string[]) => xs.filter((x, i, all) => x && all.findIndex((y) => same(x, y)) === i);

/** The services staff can pick the core from: the client's form ones first, then the rest (the current core among them). */
export function coreChoices(draft: ScanDraft, core: string): { form: string[]; other: string[] } {
    const services = draft.business.services.map((x) => ({ name: x.name.trim(), form: x.source === "form" }));
    const form = unique(services.filter((x) => x.form).map((x) => x.name));
    const other = unique([core.trim(), ...services.map((x) => x.name)]).filter((x) => !form.some((f) => same(f, x)));
    return { form, other };
}

/** The Core service section shows: a goal card asks, or there is a core or a service to pick it from. */
export function showsCoreService(draft: ScanDraft): boolean {
    if (draft.decisions.some((d) => d.type === "form_goal_core")) return true;
    const core = draft.words.find((w) => w.variable === "core_service")?.value ?? "";
    const { form, other } = coreChoices(draft, core);
    return form.length + other.length > 0;
}
